import AuthorPreview from "components/User/AuthorPreview/AuthorPreview";
import { t } from "i18next";
import React from "react";
import { useQuery } from "react-query";
import "./UsersList.css";
import { AsyncUserCard } from "components/User/Card/UserCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export function AsyncUsersList(props) {
	const { queryKey, queryFn } = props;
	const { isLoading, data } = useQuery(queryKey, queryFn, { retry: false });

	const getItems = (data) => {
		if (!data) return [];
		if (Array.isArray(data)) return data;
		if (data.Items && Array.isArray(data.Items)) return data.Items;
		return [];
	};

	if (isLoading) {
		return <div className="userlist-placeholder">{t("Groups.LOADING_USERS")}</div>;
	}

	let items = getItems(data);

	if (items.length === 0) {
		return props.hideIfNoData ? null : (
			<div className="userlist-placeholder">{t("Groups.NO_USERS")}</div>
		);
	}

	if (props.treat) {
		items = items.map(props.treat);
	}

	if (props.sort) {
		items = items.sort(props.sort);
	} else {
		items = items.sort((a, b) => (a.LastName < b.LastName ? -1 : 1));
	}

	return (
		<UsersList users={items} {...props} />
	);
}

function UsersList(props) {
	const { users, max, width, className, total, fullView } = props;
	const row_ref = React.createRef();
	const history = useHistory();


	if (!users?.length)
		return (props.hideIfNoData ? false : <div>{t("Groups.NO_USERS")}</div>);

	function handleScroll(e) {
		e.stopPropagation();
		if (row_ref?.current)
			row_ref.current.scrollLeft = row_ref.current.scrollLeft + e.deltaY;
	}

	function genList() {
		if (!users || users.length === 0) {
			console.warn("⚠️ No users to display");
			return [];
		}

		const limitedUsers = max ? users.slice(0, max) : users;

		return limitedUsers.map((user) => {
			const key = user.EmployeId ?? user.EmployesId;

			const goToContact = (e) => {
				const employeId = user.EmployeId ?? user.EmployesId
				history.push("/contacts/?employeId=" + employeId);
			};

			return (
				<div key={key} onClick={goToContact}>
					{fullView ? (
						<AsyncUserCard employeId={user.EmployeId ?? user.EmployesId} />
					) : (
						<AuthorPreview
							companyId={user.CompanyId}
							employeId={user.EmployeId ?? user.EmployesId}
							title={
								(user.EmployeFirstName ?? user.FirstName ?? "") + " " +
								(user.EmployeLastName ?? user.LastName ?? "").toUpperCase()
							}
							imgWidth={width}
							imgRes={"Url_Min"}
						/>
					)}
				</div>
			);
		});
	}

	return (
		<div className={"UsersList" + (className ? " " + className : "")}>

			<div className="list gap-2" ref={row_ref} onWheel={handleScroll}>
				{genList()}
			</div>
			<div className="more-users">
				{
					(users.length > max || total) &&
					<div>
						<div
							title={users.slice(max, users.length).map(a => (a.EmployeLastName + " " + a.EmployeFirstName)).join("\n")}
							className="more">{!total ? (users.length - max) + "+" : users.length}
						</div>
					</div>
				}
			</div>
		</div>
	);
}

export default UsersList;
